
import * as angular from "angular";

export function trustedSource($sce) {

    return (url: string) => {
        return $sce.trustAsResourceUrl(url);
    }
}
